import { Core } from '../core/core';
import { SetStateOptions } from '../interfaces/state.interface';
import { dispatch } from '../store/dispatch';

export function setMemo(key: string, value: any, options: SetStateOptions = { save: true }) {
    dispatch({
        type: 'MEMO_UPDATE',
        key: key,
        value: value,
    });

    if (Core.storage && options.save) {
        try {
            Core.storage.set(key, value);
        } catch (err) {}
    }
}
